import React from 'react';
import { ArrowRight } from 'lucide-react';
import './LogoSection.css';

import nvidiaLogo   from './nvidia.png';
import intelLogo    from './intel.png';
import microsoftLogo from './startup.png'; // renamed for clarity

const partnerLogos = [
  {
    name: 'NVIDIA',
    description: 'Working with NVIDIA to accelerate AI innovation through the NVIDIA Inception program.',
    imageUrl: nvidiaLogo,
  },
  {
    name: 'Intel',
    description: 'Collaborating with Intel Liftoff to optimize performance and scale efficiently.',
    imageUrl: intelLogo,
  },
  {
    name: 'Microsoft',
    description: 'Building cloud solutions with Microsoft for Startups to reach global customers.',
    imageUrl: microsoftLogo,
  },
];

const LogoSection = () => {
  return (
    <section className="logo-section">
      <div className="logo-section-container">
        <h2 className="logo-section-title">
          Innovation Partners
        </h2>
        <p className="logo-section-subtitle">
          Working with industry leaders to bring cutting-edge technology to our customers.
        </p>

        <div className="logo-cards">
          {partnerLogos.map((partner, index) => (
            <div
              key={partner.name}
              className="logo-card"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="logo-card-image-container">
                <img
                  src={partner.imageUrl}
                  alt={partner.name}
                  className="logo-card-image"
                />
              </div>
              <div className="logo-card-content">
                <h3 className="logo-card-title">{partner.name}</h3>
                <p className="logo-card-description">{partner.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoSection;